import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from '../../utils/dateConvert'
import '../../styles/events/events.scss';

class EditEvent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      eventDetails: [],
      name: "",
      description: "",
      type: "",
      Configuration: "",
      status: "",
      name_error: false,
      config_error: false,
      invalid_json: false,
      type_error: false
    };
    this.formSubmit = false;
  }

  async componentDidMount() {
    let eventId = this.props.match.params.id;
    let selectUrl = `${apiHost}/api/Event/SelectedEvent/${eventId}`;
    this.postEventDetails(selectUrl);
  }

  postEventDetails = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      const eventDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      this.setState({ eventDetails: eventDetails.data });
      this.setState({
        name: eventDetails.data.name,
        description: eventDetails.data.description,
        type: eventDetails.data.type,
        Configuration: eventDetails.data.config,
        status: eventDetails.data.status,
      });

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handleNameChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == '') {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }

  handleDescriptionChange = (e) => {
    console.log(e.target.value);
    this.setState({ description: e.target.value });
  }

  handleTypeChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == '') {
      this.setState({ type_error: true });
    } else {
      this.setState({ type_error: false });
    }
    this.setState({ type: e.target.value });
  }

  handleConfigChange = (e) => {
    console.log(e.target.value);
    this.setState({ Configuration: e.target.value });

    if (e.target.value == '') {
      this.setState({ config_error: true })
      this.setState({ invalid_json: false })
    } else {
      this.setState({ config_error: false });
      try {
        JSON.parse(e.target.value)
        this.setState({ invalid_json: false })
      } catch (e) {
        console.log(`parsing failed ${e}`)
        this.setState({ invalid_json: true })
      }
    }
  }
  handleStatusChange = (e) => {
    console.log(e.target.value);
    this.setState({ status: e.target.value });
  }

  handleSubmit = async () => {
    this.formSubmit = true;

    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }
    if (this.state.type == "") {
      this.setState({ type_error: true });
      this.formSubmit = false;
    }
    if (this.state.Configuration == "") {
      this.setState({ config_error: true });

      this.formSubmit = false;
    }
    if (this.state.invalid_json) {
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        await axios.post(
          `${apiHost}/api/Event/UpdateEvent`,
          {
            id: this.props.match.params.id,
            name: this.state.name,
            description: this.state.description,
            type: this.state.type,
            config: this.state.Configuration,
            status: this.state.status,
            dbUpdated: this.state.eventDetails.dbUpdated,
            dbCreated: this.state.eventDetails.dbCreated,

          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        );

        this.props.setLoadingPageAction(false);
        this.props.history.push("/events");
      } catch (e) {
        this.props.setLoadingPageAction(false);
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          if (e.response.status == "305") {
            this.props.setErrorMessageAction("Invalid Json Format in Configuration");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }

  normalizeStatus = (status) => {
    const normalizedStatus = (status || "").toString().toLowerCase();

    if (normalizedStatus === "0" || normalizedStatus === "disabled" || normalizedStatus === "disable") {
      return "disabled";
    }

    return "active";
  }

  getStatusLabel = () => {
    return this.normalizeStatus(this.state.status) === "disabled" ? "Disabled" : "Active";
  }

  render() {
    const { name, description, type, Configuration, status } = this.state;
    const statusLabel = this.getStatusLabel();
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit Event </title>
          </Helmet>
          <div className="contentBody events-page-shell">
            <div className="contentWrapper event-edit-page">
              <div className="event-edit-header">
                <div>
                  <span className="event-edit-kicker">Edit Event</span>
                  <h2>{name || "Event"}</h2>
                  <div className="event-edit-subtitle">
                    <span>{type ? `Type ${type}` : "Type not set"}</span>
                    <span className={`event-record-badge-${this.normalizeStatus(status)}`}>
                      {statusLabel}
                    </span>
                  </div>
                  <p>Review and update event name, type, configuration and status.</p>
                </div>

                <div className="event-edit-header-actions">
                  <Button
                    variant="light"
                    onClick={() => {
                      this.props.history.push("/events");
                    }}
                  >
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleSubmit}>
                    Save Changes
                  </Button>
                </div>
              </div>

              <Form className="event-edit-form">
                <section className="event-edit-tile">
                  <div className="event-edit-section-title">
                    <h3>Event Details</h3>
                    <p>Identity and description for this event definition.</p>
                  </div>

                  <div className="event-edit-grid">
                    <Form.Group controlId="eventName">
                      <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={name}
                      onChange={this.handleNameChange}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                    </Form.Group>

                    <Form.Group controlId="eventType">
                      <Form.Label>Type</Form.Label>
                      <Form.Control
                        type="number"
                        value={type}
                        onChange={this.handleTypeChange}
                      />
                      <p
                        style={
                          this.state.type_error
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Type field is required.
                      </p>
                    </Form.Group>

                    <Form.Group className="event-edit-wide" controlId="eventDescription">
                      <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      value={description}
                      onChange={this.handleDescriptionChange}
                      rows="2"
                    />
                    </Form.Group>
                  </div>
                </section>

                <section className="event-edit-tile">
                  <div className="event-edit-section-title">
                    <h3>Configuration</h3>
                    <p>Event configuration payload and availability status.</p>
                  </div>

                  <div className="event-edit-grid">
                    <Form.Group className="event-edit-wide" controlId="eventConfiguration">
                      <Form.Label>Configuration</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="5"
                        value={Configuration}
                        onChange={this.handleConfigChange}
                      />
                      <p
                        style={
                          this.state.config_error
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Configuration field is required.
                      </p>
                      <p
                        style={
                          this.state.invalid_json
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        Invalid Json.
                      </p>
                </Form.Group>

                    <Form.Group controlId="eventStatus">
                      <Form.Label>Status</Form.Label>
                    <Form.Control as="select" value={status} onChange={this.handleStatusChange}>
                      <option value="1">Active</option>
                      <option value="0">Disabled</option>

                    </Form.Control>
                    </Form.Group>
                  </div>
                </section>

                <div className="event-edit-meta">
                  <div>
                    <span>Created</span>
                    <strong>{utcToLocal(this.state.eventDetails.dbCreated)}</strong>
                  </div>
                  <div>
                    <span>Updated</span>
                    <strong>{utcToLocal(this.state.eventDetails.dbUpdated)}</strong>
                  </div>
                </div>

                <div className="event-edit-footer">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.push("/events");
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit}
                  >
                    Save Changes
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.loading
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(EditEvent);
